import React from 'react';
import PlaidLinkContent from './PlaidLinkContent';
import { PlaidLinkProvider } from './PlaidLinkContext';

const Plaid = ({ resource, onLoadLink, ...rest }) => {
  return (
    <PlaidLinkProvider resource={resource} onLoadLink={onLoadLink}>
      <PlaidLinkContent
        resource={resource}
        {...rest}
      />
    </PlaidLinkProvider>
  );
};

export default Plaid;
